module.exports = __webpack_public_path__ + "static/media/Huis-1-2.bc06af30.jpg";